import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import DynamicFormPage from '../../components/DynamicFormPage';
import { getAdminUserDetails, getAdminUserPermissions, updateAdminUserPermissions } from '../../helpers/http_admin_users_requests';
import { useQuery } from '@tanstack/react-query';

export default function AdminUserPermissions() {

    const { id } = useParams();

    const userDataQuery = useQuery({ queryKey: ['getAdminUserDetails', id], queryFn: () => getAdminUserDetails(id), staleTime: 1000 * 5 });

    const userPermissionsQuery = useQuery({ queryKey: ['getAdminUserPermissions', id], queryFn: () => getAdminUserPermissions(id), staleTime: 1000 * 5 });

    const { user_admin_data: userData = [] } = userDataQuery?.data?.data ?? {};

    const { data: userPermissions = [] } = userPermissionsQuery?.data?.data ?? {};

    const homeInputOptions = [
        { value: 0, label: "SEM ACESSO" },
        { value: 1, label: "Pedidos" },
        { value: 2, label: "Produção" },
        { value: 3, label: "Clientes" },
        { value: 4, label: "Produtos" },
        { value: 5, label: "Cotações" },
        { value: 6, label: "Financeiro" },
    ];

    const permissionOptions = {
        orders: [
            { value: 0, label: "SEM ACESSO" },
            { value: 1, label: "Pode VISUALIZAR" },
            { value: 2, label: "Pode EDITAR" },
            { value: 3, label: "Pode CADASTRAR" },
            { value: 4, label: "Pode EXCLUIR" },
            { value: 5, label: "ADMINISTRADOR" }
        ],
        products: [
            { value: 0, label: "SEM ACESSO" },
            { value: 1, label: "Pode VISUALIZAR" },
            { value: 2, label: "Pode EDITAR" },
            { value: 3, label: "Pode CADASTRAR" },
            { value: 4, label: "Pode EXCLUIR" },
            { value: 5, label: "ADMINISTRADOR" }
        ],
        production: [
            { value: 0, label: "SEM ACESSO" },
            { value: 1, label: "Pode VISUALIZAR" },
            { value: 2, label: "Pode EDITAR" },
            { value: 5, label: "ADMINISTRADOR" }
        ],
        price: [
            { value: 0, label: "SEM ACESSO" },
            { value: 1, label: "Pode VISUALIZAR" },
            { value: 2, label: "Pode EDITAR" },
            { value: 5, label: "ADMINISTRADOR" }
        ],
        users: [
            { value: 0, label: "SEM ACESSO" },
            { value: 1, label: "Pode VISUALIZAR" },
            { value: 2, label: "Pode EDITAR" },
            { value: 3, label: "Pode CADASTRAR" },
            { value: 4, label: "Pode EXCLUIR" },
            { value: 5, label: "ADMINISTRADOR" }
        ],
        customers: [
            { value: 0, label: "SEM ACESSO" },
            { value: 1, label: "Pode VISUALIZAR" },
            { value: 2, label: "Pode EDITAR" },
            { value: 3, label: "Pode CADASTRAR" },
            { value: 4, label: "Pode EXCLUIR" },
            { value: 5, label: "ADMINISTRADOR" }
        ],
        relationship: [
            { value: 0, label: "SEM ACESSO" },
            { value: 1, label: "Pode VISUALIZAR" },
            { value: 3, label: "Pode CADASTRAR" },
            { value: 5, label: "ADMINISTRADOR" }
        ],
        report: [
            { value: 0, label: "SEM ACESSO" },
            { value: 1, label: "Pode VISUALIZAR" },
            { value: 5, label: "ADMINISTRADOR" }
        ],
        quotation: [
            { value: 0, label: "SEM ACESSO" },
            { value: 1, label: "Pode VISUALIZAR" },
            { value: 2, label: "Pode EDITAR" },
            { value: 5, label: "ADMINISTRADOR" }
        ],
        financial: [
            { value: 0, label: "SEM ACESSO" },
            { value: 1, label: "Pode VISUALIZAR" },
            { value: 2, label: "Pode EDITAR" },
            { value: 5, label: "ADMINISTRADOR" }
        ],
        logs: [
            { value: 0, label: "SEM ACESSO" },
            { value: 1, label: "Pode VISUALIZAR" },
            { value: 2, label: "Pode EDITAR" },
            { value: 3, label: "Pode CADASTRAR" },
            { value: 4, label: "Pode EXCLUIR" },
            { value: 5, label: "ADMINISTRADOR" }
        ]
    };

    const formFieldList = [
        {
            title: 'Área Inicial do Sistema',
            fields: [
                {
                    name: "home_area",
                    label: "Área Inicial",
                    type: "select",
                    options: homeInputOptions,
                    required: true,
                },
            ],
        },
        {
            title: 'Permissões por Módulo',
            fields: [
                {
                    name: "orders",
                    label: "Pedidos",
                    type: "select",
                    options: permissionOptions.orders,
                    required: true,
                },
                {
                    name: "products",
                    label: "Produtos",
                    type: "select",
                    options: permissionOptions.products,
                    required: true,
                },
                {
                    name: "production",
                    label: "Produção",
                    type: "select",
                    options: permissionOptions.production,
                    required: true,
                },
                {
                    name: "price",
                    label: "Cotações",
                    type: "select",
                    options: permissionOptions.price,
                    required: true,
                },
                {
                    name: "users",
                    label: "Usuários",
                    type: "select",
                    options: permissionOptions.users,
                    required: true,
                },
                {
                    name: "customers",
                    label: "Clientes",
                    type: "select",
                    options: permissionOptions.customers,
                    required: true,
                },
                {
                    name: "relationship",
                    label: "Relacionamento",
                    type: "select",
                    options: permissionOptions.relationship,
                    required: true,
                },
                {
                    name: "report",
                    label: "Relatórios",
                    type: "select",
                    options: permissionOptions.report,
                    required: true,
                },
                {
                    name: "quotation",
                    label: "Orçamentos",
                    type: "select",
                    options: permissionOptions.quotation,
                    required: true,
                },
                {
                    name: "financial",
                    label: "Financeiro",
                    type: "select",
                    options: permissionOptions.financial,
                    required: true,
                },
                {
                    name: "logs",
                    label: "Configuração",
                    type: "select",
                    options: permissionOptions.logs,
                    required: true,
                }
            ]
        }
    ];

    const navigate = useNavigate();

    const handleSubmit = (data) => {
        updateAdminUserPermissions(data, () => navigate('/usuarios'));
    };

    return (
        <DynamicFormPage
            isLoading={userDataQuery?.isFetching}
            title={`Usuário ${(userData.complete_name || '').split(' ')[0]} - Permissões`}
            formFieldList={formFieldList}
            onCancel={() => navigate(-1)}
            initialData={userPermissions}
            onSubmit={handleSubmit}
        />
    );
};
